export default {
  name: 'tenth',
  data: function() {
    return {
      address: '',
      name: '',
      country: '',
      showNameSearch: false,
      showNameorAddressSearch: false,
      showAddressSearch: false,
      showInput: false,
      instaNumber: '',
      installerObject: {},
      byName: false,
      byAddress: false,
      self: false,
      validMail: true,
      validManuelMail: true,
      select_countries: [
        { countryCode: 'AE', countryName: 'United Arab Emirates' },
        { countryCode: 'AL', countryName: 'Albania' },
        { countryCode: 'AM', countryName: 'Armenia' },
        { countryCode: 'AT', countryName: 'Austria' },
        { countryCode: 'AZ', countryName: 'Azerbaijan' },
        { countryCode: 'BA', countryName: 'Bosnia and Herzegovina' },
        { countryCode: 'BE', countryName: 'Belgium' },
        { countryCode: 'BG', countryName: 'Bulgaria' },
        { countryCode: 'BH', countryName: 'Bahrain' },
        { countryCode: 'BY', countryName: 'Belarus' },
        { countryCode: 'CA', countryName: 'Canada' },
        { countryCode: 'CH', countryName: 'Switzerland' },
        { countryCode: 'CY', countryName: 'Cyprus' },
        { countryCode: 'CZ', countryName: 'Czech Republic' },
        { countryCode: 'DE', countryName: 'Germany' },
        { countryCode: 'DK', countryName: 'Denmark' },
        { countryCode: 'DZ', countryName: 'Algeria' },
        { countryCode: 'EE', countryName: 'Estonia' },
        { countryCode: 'EG', countryName: 'Egypt' },
        { countryCode: 'ES', countryName: 'Spain' },
        { countryCode: 'FI', countryName: 'Finland' },
        { countryCode: 'FR', countryName: 'France' },
        { countryCode: 'GB', countryName: 'United Kingdom of Great Britain' },
        { countryCode: 'GR', countryName: 'Greece' },
        { countryCode: 'HR', countryName: 'Croatia' },
        { countryCode: 'HU', countryName: 'Hungary' },
        { countryCode: 'IE', countryName: 'Ireland' },
        { countryCode: 'IL', countryName: 'Israel' },
        { countryCode: 'IS', countryName: 'Iceland' },
        { countryCode: 'IT', countryName: 'Italy' },
        { countryCode: 'JO', countryName: 'Jordan' },
        { countryCode: 'KG', countryName: 'Kyrgyzstan' },
        { countryCode: 'KW', countryName: 'Kuwait' },
        { countryCode: 'KZ', countryName: 'Kazakhstan' },
        { countryCode: 'LB', countryName: 'Lebanon' },
        { countryCode: 'LI', countryName: 'Liechtenstein' },
        { countryCode: 'LT', countryName: 'Lithuania' },
        { countryCode: 'LU', countryName: 'Luxembourg' },
        { countryCode: 'LV', countryName: 'Latvia' },
        { countryCode: 'MA', countryName: 'Morocco' },
        { countryCode: 'MD', countryName: 'Moldova' },
        { countryCode: 'MK', countryName: 'Macedonia' },
        { countryCode: 'MN', countryName: 'Mongolia' },
        { countryCode: 'MT', countryName: 'Malta' },
        { countryCode: 'MX', countryName: 'Mexico' },
        { countryCode: 'NG', countryName: 'Nigeria' },
        { countryCode: 'NL', countryName: 'Netherlands' },
        { countryCode: 'NO', countryName: 'Norway' },
        { countryCode: 'OM', countryName: 'Oman' },
        { countryCode: 'PA', countryName: 'Panama' },
        { countryCode: 'PK', countryName: 'Pakistan' },
        { countryCode: 'PL', countryName: 'Poland' },
        { countryCode: 'PT', countryName: 'Portugal' },
        { countryCode: 'QA', countryName: 'Qatar' },
        { countryCode: 'RO', countryName: 'Romania' },
        { countryCode: 'RS', countryName: 'Serbia' },
        { countryCode: 'RU', countryName: 'Russia' },
        { countryCode: 'SA', countryName: 'Saudi Arabia' },
        { countryCode: 'SE', countryName: 'Sweden' },
        { countryCode: 'SI', countryName: 'Slovenia' },
        { countryCode: 'SK', countryName: 'Slovakia' },
        { countryCode: 'TJ', countryName: 'Tajikistan' },
        { countryCode: 'TM', countryName: 'Turkmenistan' },
        { countryCode: 'TN', countryName: 'Tunisia' },
        { countryCode: 'TR', countryName: 'Turkey' },
        { countryCode: 'UA', countryName: 'Ukraine' },
        { countryCode: 'US', countryName: 'United States of America' },
        { countryCode: 'UZ', countryName: 'Uzbekistan' },
        { countryCode: 'ZA', countryName: 'South Africa' }
      ]
    }
  },
  props: ['installer', 'landingText', 'email', 'self_installed'],

  computed: {
    notConnectNow: function() {
      return this.$store.getters.notConnectNow
    }
  },
  methods: {
    validManuelEmail: function() {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      this.validManuelMail = re.test(this.installer.email)
    },
    goToSuccess: function() {
      this.$emit('goToEnd', this.installer, this.email, this.self)
    },
    chosenInstaller: function(index) {
      this.instaNumber = index

      this.installer.name = this.installerObject[index].name
      this.installer.email = this.installerObject[index].mail
      this.installer.phone = this.installerObject[index].phone
      this.installer.streetNr = this.installerObject[index].address1
      this.installer.pcCity = this.installerObject[index].city + ' ' + this.installerObject[index].postcode
    },
    searchBtnClicked: function(btnName) {
      this.showNameorAddressSearch = true
      if (btnName === 'name') {
        this.showNameSearch = true
        this.showAddressSearch = false
        this.byName = true
        this.byAddress = false
      } else if (btnName === 'city') {
        this.showAddressSearch = true
        this.showNameSearch = false
        this.byAddress = true
        this.byName = false
      }
    },
    searchInstaller: function() {
      let search = false
      let _par = {
        params: {
          countryISO: this.country.countryCode
        }
      }
      if (this.byName && this.name && this.name !== '') {
        _par.params.name = this.name
        search = true
      } else if (this.byAddress && this.address && this.address !== '') {
        _par.params.address = this.address
        search = true
      }
      this.installerObject = []
      if (search) {
        this.$http.get('installer', _par)
          .then(response => {
            if (response && response.body) {
              console.log('GET /installer', response.body)
              this.installerObject = response.body
            // this.setUpDashboardData(response.body)
            // this.setNotificationBar()
            }
          })
        // error callback
          .catch(err => {
            console.log(err)
          })
      }
    }
  },
  beforeMount: function() {
    this.country = this.select_countries.filter(country => {
      return country.countryCode === this.$route.params.id.split('_')[1]
    })[0]
  }
}


// WEBPACK FOOTER //
// ./src/components/plan/subComponents/tenth/tenth.js